if (typeof MainSearch !== 'function') {
	class MainSearch extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				tabContainer: '.main-search__tabs',
				tab: '.main-search__tabs .button',
				results: '.main-search__results .results',
				summaryText: '.summary__text',
				filtersMobile: '#FacetFiltersFormMobile',
				filtersDesktop: '#FacetFiltersForm',
			};

			this.elements = {
				tabs: this.querySelectorAll(this.selectors.tab),
				results: this.querySelectorAll(this.selectors.results),
				summaryText: this.querySelector(this.selectors.summaryText),
				tabContainer: this.querySelector(this.selectors.tabContainer),
			};

			this.classes = {
				active: 'active',
				hidden: 'hidden',
			};

			this.initialFiltering = {};

			this.getInitialFiltering();
			this.addListeners();
		}

		addListeners() {
			const { tabs } = this.elements;

			tabs.forEach((tab) => {
				tab.addEventListener('click', (e) => {
					e.preventDefault();

					this.toggleTab(tab);
				});
			});

			this.addEventListener('facet-filters-form:change', () => {
				const newParams = this.getParams(new URL(window.location.href).searchParams);
				this.compareViews(newParams);
			});
		}

		toggleTab(tab) {
			const { tabs, results } = this.elements;
			const { active, hidden } = this.classes;
			const tabName = tab.dataset.tab;

			tabs.forEach((element) => {
				if (element !== tab) {
					element.classList.remove(active);
				} else {
					element.classList.add(active);
				}
			});

			results.forEach((result) => {
				if (result.dataset.tab !== tabName) {
					result.classList.add(hidden);
				} else {
					result.classList.remove(hidden);
				}
			});
		}

		getFacetsForm() {
			let isMobile = window.innerWidth < 1024;

			if (isMobile && document.querySelector(this.selectors.filtersMobile)) {
				return document.querySelector(this.selectors.filtersMobile);
			} else if (document.querySelector(this.selectors.filtersDesktop)) {
				return document.querySelector(this.selectors.filtersDesktop);
			} else {
				return false;
			}
		}

		getInitialFiltering() {
			const loadingFilters = this.getParams(new URL(window.location.href).searchParams);

			if (!Object.keys(loadingFilters).every((el) => el === 'q' || el === 'page')) {
				if (this.getFacetsForm()) {
					this.initialFiltering = Object.assign({}, this.getParams(new FormData(this.getFacetsForm())));
					delete loadingFilters.page;
					this.compareViews(loadingFilters);
				} else {
					this.initialFiltering == false;
					this.showElements();
				}
			} else {
				if (this.getFacetsForm()) {
					this.initialFiltering = Object.assign({}, this.getParams(new FormData(this.getFacetsForm())));
				} else {
					this.initialFiltering == false;
				}

				this.showElements();
			}
		}

		getParams(params) {
			const params2 = new URLSearchParams(params);
			let objectToReturn = {};

			for (let p of params2.entries()) {
				objectToReturn[p[0]] = p[1];
			}

			return objectToReturn;
		}

		compareViews(newParams) {
			const isNewView =
				Object.entries(this.initialFiltering).sort().toString() === Object.entries(newParams).sort().toString();

			if (isNewView) {
				this.showElements();
			} else {
				this.hideElements();
			}
		}

		hideElements() {
			const { summaryText, tabContainer } = this.elements;
			const { hidden } = this.classes;

			summaryText.classList.add(hidden);
			tabContainer.classList.add(hidden);
		}

		showElements() {
			const { summaryText, tabContainer } = this.elements;
			const { hidden } = this.classes;

			summaryText && summaryText.classList.remove(hidden);
			tabContainer && tabContainer.classList.remove(hidden);
		}
	}

	if (!customElements.get('main-search')) {
		customElements.define('main-search', MainSearch);
	}
}
